// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackagesQueryVariables = Types.Exact<{
  filter: Types.PlanPackageFilter;
  orderBy?: Types.InputMaybe<Types.PlanPackageOrderBy>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type PlanPackagesQuery = { __typename?: 'Query', planPackages: { __typename?: 'PlanPackagesPageResult', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number }, entities: Array<{ __typename?: 'PlanPackage', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], activeOptionsCount: number, displayCode?: string | null | undefined, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined }, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType } }> }> } };

export type PlanPackagesPageDetailFragment = { __typename?: 'PlanPackage', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], activeOptionsCount: number, displayCode?: string | null | undefined, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined }, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType } }> };

export type PlanPackageProgramDataLiteFragment = { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined };

export const PlanPackageProgramDataLiteFragmentDoc = gql`
    fragment PlanPackageProgramDataLite on ProgramData {
  id
  bedrooms
  fullBaths
  halfBaths
  sellableSqft
}
    `;
export const PlanPackagesPageDetailFragmentDoc = gql`
    fragment PlanPackagesPageDetail on PlanPackage {
  id
  name
  updatedAt
  activeOptionsCount
  displayCode
  status: effectiveStatus {
    code
    name
  }
  maxProgramData {
    ...PlanPackageProgramDataLite
  }
  minProgramData {
    ...PlanPackageProgramDataLite
  }
  options {
    id
    type {
      id
      isElevation
    }
  }
  aggregateLatest {
    id
  }
  assets {
    id
    asset {
      id
      previewUrl(resizing: {width: 321, region: FULL})
    }
    type {
      code
    }
  }
}
    ${PlanPackageProgramDataLiteFragmentDoc}`;
export const PlanPackagesDocument = gql`
    query PlanPackages($filter: PlanPackageFilter!, $orderBy: PlanPackageOrderBy, $page: PageFilter) {
  planPackages(filter: $filter, orderBy: $orderBy, page: $page) {
    pageInfo {
      hasNextPage
      totalCount
    }
    entities {
      ...PlanPackagesPageDetail
    }
  }
}
    ${PlanPackagesPageDetailFragmentDoc}`;

/**
 * __usePlanPackagesQuery__
 *
 * To run a query within a React component, call `usePlanPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePlanPackagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables> & ({ variables: PlanPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackagesQuery, PlanPackagesQueryVariables>(PlanPackagesDocument, options);
      }
export function usePlanPackagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackagesQuery, PlanPackagesQueryVariables>(PlanPackagesDocument, options);
        }
// @ts-ignore
export function usePlanPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackagesQuery, PlanPackagesQueryVariables>;
export function usePlanPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackagesQuery | undefined, PlanPackagesQueryVariables>;
export function usePlanPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagesQuery, PlanPackagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackagesQuery, PlanPackagesQueryVariables>(PlanPackagesDocument, options);
        }
export type PlanPackagesQueryHookResult = ReturnType<typeof usePlanPackagesQuery>;
export type PlanPackagesLazyQueryHookResult = ReturnType<typeof usePlanPackagesLazyQuery>;
export type PlanPackagesSuspenseQueryHookResult = ReturnType<typeof usePlanPackagesSuspenseQuery>;
export type PlanPackagesQueryResult = ApolloReactCommon.QueryResult<PlanPackagesQuery, PlanPackagesQueryVariables>;